import React from 'react';
import PropTypes from 'prop-types';

import Loading from '../../../../shared/loading';
import ErrorBoundary from '../../../../shared/error-boundary';
import defaultOnErrorHandler from '../../../../shared/default-on-error-handler';
import debounceAction from '../../../../shared/debounce-action';
import Validator from '../../../../shared/validator';
import { editorValidate } from '../channel-editor-postal';
import { updateOriginalUrl } from '../../../../services/wire/edit-services';

export default class ExclusiveContentControl extends React.Component {
  static propTypes = {
    wireId: PropTypes.number.isRequired,
    originalUrl: PropTypes.string,
  }

  static defaultProps = {
    originalUrl: '',
  }

  constructor(props, context) {
    super(props, context);

    this.validator = new Validator({
      url: state => state.isExclusiveContent || Validator.UrlRegex.test(state.originalUrl),
      emptyUrl: state => state.isExclusiveContent || !!state.originalUrl.length,
    });

    this.state = {
      isExclusiveContent: !this.props.originalUrl,
      originalUrl: this.props.originalUrl,
      validations: this.validator.getValidations(),
    };

    this.saveOriginalUrl = debounceAction({
      getCurrentValue: () => this.state.originalUrl,
      actionPromise: () => updateOriginalUrl(this.props.wireId, this.state.originalUrl),
      onBeforeAction: () => this.loading.start(),
      onError: e => defaultOnErrorHandler(e, 'Error saving original URL'),
      onAfterAction: () => this.loading.stop(),
    });

    editorValidate(this, 'exclusiveness');
  }

  handleOriginalUrlChange(e) {
    const originalUrl = e.target.value;

    this.setState(state => {
      state.originalUrl = originalUrl;
      if (!state.isExclusiveContent) {
        state.validations = this.validator.validateForm(state);
        if (state.validations.urlValid) {
          this.saveOriginalUrl();
        }
      } else {
        state.validations = {
          urlValid: true,
          emptyUrlValid: true,
          formValid: true,
        };
      }
      return state;
    });
  }

  handleIsExclusiveContentChange(e) {
    const isExclusiveContent = e.target.value === 'true';

    this.setState({ isExclusiveContent });
    if (isExclusiveContent) {
      this.setState({ originalUrl: '' });
      this.saveOriginalUrl();
    }
  }

  render() {
    return (
      <ErrorBoundary>
        <aside className="sidebar-item">
          <form className="--user-facing">
            <section className="form-group">
              <span className="sidebar-item-desc">Is the content exclusive to Livewire?</span>
              <label htmlFor="exclusive-yes" className="sidebar-item-radio-group">
                <input
                  id="exclusive-yes"
                  type="radio"
                  value
                  checked={this.state.isExclusiveContent}
                  onChange={e => this.handleIsExclusiveContentChange(e)}
                />
                Yes
              </label>
              <label htmlFor="exclusive-no" className="sidebar-item-radio-group">
                <input
                  id="exclusive-no"
                  type="radio"
                  value={false}
                  checked={!this.state.isExclusiveContent}
                  onChange={e => this.handleIsExclusiveContentChange(e)}
                />
                No
              </label>
              <Loading variant="sip" ref={el => (this.loading = el)} />
              {!this.state.isExclusiveContent && (
                <p className={`form-group ${this.state.validations.formValid ? '' : 'has-error'}`}>
                  <input
                    className="sidebar-item-input-text sidebar-item-url"
                    type="text"
                    value={this.state.originalUrl}
                    onChange={e => this.handleOriginalUrlChange(e)}
                    placeholder="Original URL"
                  />
                  {!this.state.validations.emptyUrlValid || this.state.validations.urlValid || <span className="help-block">Please enter a valid URL.</span>}
                  {!!this.state.validations.emptyUrlValid || <span className="help-block">Please enter the URL of the original article.</span>}
                </p>
              )}
            </section>
          </form>
        </aside>
      </ErrorBoundary>
    );
  }
}
